<!-- @format -->

<ng-container *transloco="let t">
  @if (data$ | async; as data) {
    <app-module-info-header
      [module]="$any(data.module)"
      [versions]="$any(data.moduleVersions)"
      [attainment]="data.selectedModuleAttainment"
      (closeModal)="activeModal.close()"
      (setModuleInfoVersionChange)="versionChangeSubject$.next($event)">
      <!-- Currently viewed version differs from the initial (selected in plan) version -->
      @if (this.values.moduleId !== data.module.id) {
        <ng-template #headerNotification>
          <sis-contextual-notification [variant]="'light'">
            @if (!data.canUseCurrentVersion) {
              <span>
                @if (data.module.type === "DegreeProgramme") {
                  <ng-container>{{ t("MODULE_INFO.DEGREE_PROGRAMME_VERSION_NOT_COMPATIBLE") }}</ng-container>
                }
                @if (data.module.type === "StudyModule") {
                  <ng-container>{{ t("MODULE_INFO.STUDY_MODULE_VERSION_NOT_COMPATIBLE") }}</ng-container>
                }
              </span>
            }
            @if (data.canUseCurrentVersion) {
              <span>
                @if (data.module.type === "DegreeProgramme") {
                  <ng-container>{{ t("MODULE_INFO.DEGREE_PROGRAMME_VERSION_IS_COMPATIBLE") }}</ng-container>
                }
                @if (data.module.type === "StudyModule") {
                  <ng-container>{{ t("MODULE_INFO.STUDY_MODULE_VERSION_IS_COMPATIBLE") }}</ng-container>
                }
                <sis-button [type]="'button'" [link]="true" (clicked)="openVersionChangeWarningModal(this.values.moduleId, data.module.id)">
                  {{ t("MODULE_INFO.VERSION_USE_BTN") }}
                </sis-button>
              </span>
            }
          </sis-contextual-notification>
        </ng-template>
      }
    </app-module-info-header>
    @if (data.showModuleAttainmentApplicationBlock) {
      <div class="module-attainment-application-block">
        <div class="row">
          <div class="col-12 col-md-8">
            <p>
              @switch (values.moduleAttainmentApplicationWrapper.mode) {
                @case ("FLAT") {
                  <span>
                    {{ t("MODULE_INFO.MODULE_ATTAINMENT_APPLICATION.FLAT_MODULE_INFO") }}
                  </span>
                }
                @case ("RECURSIVE") {
                  <span>
                    {{ t("MODULE_INFO.MODULE_ATTAINMENT_APPLICATION.DEEP_MODULE_INFO") }}
                  </span>
                }
                @case ("APPLICATION_IS_SENT") {
                  <span>
                    {{ t("MODULE_INFO.MODULE_ATTAINMENT_APPLICATION.APPLICATION_IS_SENT_INFO") }}
                  </span>
                }
                @case ("ACTIVE_STUDY_RIGHT_NOT_FOUND") {
                  <span>
                    {{ t("MODULE_INFO.MODULE_ATTAINMENT_APPLICATION.ACTIVE_STUDY_RIGHT_NOT_FOUND_INFO") }}
                  </span>
                }
              }
              <span class="warning-guidance">
                {{ t("MODULE_INFO.MODULE_ATTAINMENT_APPLICATION.MODULE_APPLICATION_NOTIFICATION") }}
              </span>
            </p>
          </div>
          <div class="col-12 col-md-4 button-holder">
            @if (
              !!values.moduleAttainmentApplicationWrapper.applyForModuleAttainment &&
              !(values.moduleAttainmentApplicationWrapper?.applications?.length > 0)
            ) {
              <button
                class="btn btn-white btn-lg"
                data-cy="apply-for-module-attainment-button"
                [disabled]="attainmentApplicationSendPending"
                (click)="applyForModuleAttainmentApplication(); $event.stopPropagation()">
                {{ t("MODULE_INFO.MODULE_ATTAINMENT_APPLICATION.APPLY") }}
              </button>
            }
            @if (values.moduleAttainmentApplicationWrapper?.applications?.length > 0) {
              <button
                data-cy="show-module-attainment-application-button"
                #showModuleAttainmentApplicationButton
                class="btn btn-white btn-lg"
                (click)="
                  navigateToModuleAttainmentApplication(values.moduleAttainmentApplicationWrapper?.applications ?? []);
                  $event.stopPropagation()
                ">
                {{ t("MODULE_INFO.MODULE_ATTAINMENT_APPLICATION.SHOW_APPLICATION") }}
              </button>
            }
          </div>
        </div>
      </div>
    }
    @if (data.showDegreeProgrammeWorkflowRequestedBlock) {
      <div class="degree-programme-application-requested-block">
        <div class="row">
          <div class="col-12">
            <span>{{ t("MODULE_INFO.GRADUATION.GRADUATION_REQUESTED", { degreeProgrammeName: data.module.name | localizedString }) }}</span>
            <a
              id="navigate-to-dpa-application"
              [uiSref]="'student.logged-in.profile.applications.degree-programme-attainment-workflow'"
              [uiParams]="{ applicationId: data.degreeProgrammeAttainmentWorkflow.id }"
              (click)="activeModal.close()">
              {{ t("MODULE_INFO.GRADUATION.NAVIGATE_TO_DPA_APPLICATION") }}
            </a>
          </div>
        </div>
      </div>
    }
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <sis-expandable
            [title]="t('MODULE_INFO.TITLE_BASIC')"
            [level]="3"
            [closed]="!(values?.sectionExpandableOpenSettings?.basics ?? false)">
            <ng-template sisExpandableContent>
              <app-module-info-basic-info [module]="$any(data.module)"></app-module-info-basic-info>
            </ng-template>
          </sis-expandable>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <sis-expandable
            [title]="t('MODULE_INFO.TITLE_DESCRIPTIONS')"
            [level]="3"
            [closed]="!(values?.sectionExpandableOpenSettings?.description ?? false)">
            <ng-template sisExpandableContent>
              <app-module-info-description [module]="$any(data.module)"></app-module-info-description>
            </ng-template>
          </sis-expandable>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <sis-expandable
            [title]="t('MODULE_INFO.TITLE_CLASSIFICATION')"
            [level]="3"
            [closed]="!(values?.sectionExpandableOpenSettings?.classification ?? false)">
            <ng-template sisExpandableContent>
              <app-module-info-classification [module]="$any(data.module)"></app-module-info-classification>
            </ng-template>
          </sis-expandable>
        </div>
      </div>
      @if (data.showGraduationSection) {
        <div class="row">
          <div class="col-12">
            <sis-expandable
              [title]="t('MODULE_INFO.TITLE_GRADUATION')"
              [level]="3"
              [closed]="!(values?.sectionExpandableOpenSettings?.graduation ?? false)">
              <ng-template sisExpandableContent>
                <div class="sis-mb-xs">
                  @if (!data.selectedModuleAttainment && values.isPrimaryPlan && !!data.degreeProgrammeAttainmentWorkflow) {
                    <sis-contextual-notification [variant]="'light'">
                      <span>{{
                        t("MODULE_INFO.GRADUATION.GRADUATION_REQUESTED", { degreeProgrammeName: data.module.name | localizedString })
                      }}</span>
                      <a
                        id="navigate-to-dpa-application-graduation-section"
                        [uiSref]="'student.logged-in.profile.applications.degree-programme-attainment-workflow'"
                        [uiParams]="{ applicationId: data.degreeProgrammeAttainmentWorkflow.id }"
                        (click)="activeModal.close()">
                        {{ t("MODULE_INFO.GRADUATION.NAVIGATE_TO_DPA_APPLICATION") }}
                      </a>
                    </sis-contextual-notification>
                  }
                </div>
                @if (!data.selectedModuleAttainment) {
                  <sis-graduation-instructions [organisationId]="values.organisationId"> </sis-graduation-instructions>
                  <p class="guidance">{{ t("MODULE_INFO.GRADUATION.GUIDANCE") }}</p>
                  @if (values.isPlanEligibleForGraduationApplication && !data.degreeProgrammeAttainmentWorkflow) {
                    <sis-button
                      [size]="'lg'"
                      [variant]="'primary'"
                      [id]="'open-graduation-wizard'"
                      (clicked)="openGraduationWizard(data.module)"
                      [type]="'button'">
                      {{ t("MODULE_INFO.GRADUATION.NAVIGATE_TO_APPLICATION_CREATION") }}
                    </sis-button>
                  }
                }
              </ng-template>
            </sis-expandable>
          </div>
        </div>
      }
    </div>
  }
</ng-container>
